import { render } from "./ContainerReceivableArea.vue?vue&type=template&id=15c464ce&ts=true"
import script from "./ContainerReceivableArea.vue?vue&type=script&lang=ts"
export * from "./ContainerReceivableArea.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__